import { ruleRunner } from 'validations/ruleRunner';
import { minimun } from 'validations/rules';

const Validations = [
  ruleRunner(
    'delivery_value',
    'valor do frete',
    (value: unknown) => (value ? null : () => 'Informe o valor do frete'),
    minimun('1.00')
  ),
  ruleRunner(
    'delivery_days',
    'prazo de entrega',
    (value: unknown) => (value ? null : () => 'Informe o prazo de entrega (em dias)'),
    minimun(1)
  )
];

export default Validations;
